import { Navigate, Route, Routes } from 'react-router-dom';
// import Dashbaord from '../pages/Dashboard';
import InterviewsPage from '../pages/InterviewsPage';
import LiveInterview from '../pages/LiveInterview';
import Prepare from '../pages/Prepare';
import ScorecardPage from '../pages/ScorecardPage';
import PracticeQuestionsScreen from 'src/components/prepare/PracticeQuestionScreen';
import EditProfile from 'src/pages/profile/Edit';
import PifProfileEdit from 'src/pages/pif-profile/PifProfileEdit';
import VideoAnswer from 'src/pages/VideoAnswer';
import MyApplications from 'src/pages/MyApplications';
import JapSuccessPage from 'src/pages/JapSuccess';
import MoreOptions from 'src/pages/MoreOptions';
import Job from 'src/pages/Job';
import LinkedInEmptyPage from 'src/pages/LinkedInEmptyPage';
import LinkedinOpenAuth from 'src/pages/LinkedinOpenAuth';
import EditProfileFromLinkedIn from 'src/pages/profile/EditProfileFromLinkedin';
import Contests from 'src/pages/Contests';
import ViewContest from 'src/pages/ViewContest';
import LiveSession from 'src/pages/LiveSession';
import MentorList from 'src/components/mentorSessions/MentorList';
import { useState } from 'react';
import { UIMentorUser, UserExperienceLevelType } from 'types';
import LiveContest from 'src/pages/LiveContest';
import MyChallenges from 'src/pages/MyChallenges';
import Challenge from 'src/pages/Challenge';
import MandatoryForm from 'src/pages/MandatoryForm';
import OptionalForm from 'src/pages/OptionalForm';
import TakeProfilePhoto from 'src/pages/TakeProfilePhoto';
import PlacementPrep from 'src/pages/PlacementPrep';
import { useUserContext } from 'src/context/UserProvider';
import GuestUserAssessmentPage from 'src/pages/GuestUserAssessmentPage';
import OfflineDriveDayOpportunitiesPage from 'src/pages/OfflineDriveDayOpportunitiesPage';
import { OfflineDriveAttendancePage } from 'src/pages/OfflineDriveAttendancePage';
import AssessmentScoreCard from 'src/pages/AssessmentScorecard';
import GuestUserAssessmentDashboard from 'src/components/GuestUserAssessment/GuestUserAssessmentDashboard';
import NonMasaiDrivePlacementPage from 'src/pages/nonMasaiDrivePlacement/NonMasaiDrivePlacementPage';
import UserDashboard from '../pages/UserDashboard';
import Support from 'src/pages/Support';
import PlacementDrivesListPage from 'src/pages/placementDrives/PlacementDrivesListPage';
import PlacementDriveSignInPage from 'src/pages/placementDrives/PlacementDriveSignInPage';
import PlacementDriveResumePage from 'src/pages/placementDrives/PlacementDriveResumePage';
import PlacementDriveDetailPage from 'src/pages/placementDrives/PlacementDriveDetailPage';
import PlacementDriveApplyPage from 'src/pages/placementDrives/PlacementDriveApplyPage';
import PlacementDriveStatusPage from 'src/pages/placementDrives/PlacementDriveStatusPage';
import PlacementDriveCompaniesPage from 'src/pages/placementDrives/PlacementDriveCompaniesPage';

const JobseekerRoutes = () => {
	const [mentors, setMentors] = useState<UIMentorUser[]>([]);
	const { user } = useUserContext();
	return (
		<Routes>
			<Route path="/linkedin-auth" element={<LinkedinOpenAuth />} />
			<Route path="/linkedin" element={<LinkedInEmptyPage />} />
			{/* <Route path="/dashboard" element={<Dashbaord />} /> */}
			<Route path="/dashboard" element={<Navigate to="/my-applications" replace />} />
			<Route path="/user-dashboard" element={<UserDashboard />} />
			{/* <Route path="/allMentors" element={<MentorList mentors={mentors} setMentors={setMentors} displayAll={true} />} /> */}

			{/* <Route path="/interviews" element={<InterviewsPage />} /> */}
			<Route path="/assessments" element={<InterviewsPage />} />
			<Route path="/placed-hiring-assessment/:hiringAssessmentId" element={<GuestUserAssessmentPage />} />
			<Route path="/placed-hiring-assessment/all-assessments" element={<GuestUserAssessmentDashboard />} />
			{/* challenges */}
			<Route path="/challenges" element={<MyChallenges />} />
			<Route path="/challenges/:challengeId" element={<Challenge />} />

			<Route path="/benchmarking/mandatory-details" element={<MandatoryForm />} />
			<Route path="/benchmarking/take-photo" element={<TakeProfilePhoto />} />
			<Route path="/benchmarking/optional-details" element={<OptionalForm />} />
			<Route path="/interviews/live/:id" element={<LiveInterview />} />
			<Route path="/participants/sessions/live/:sessionId" element={<LiveSession />} />
			<Route path="/scorecard/:id" element={<ScorecardPage />} />
			<Route path="/job/:jobId" element={<Job />} />

			<Route path="/contests" element={<Contests />} />
			<Route path="/contests/:contestId" element={<ViewContest />} />
			<Route path="/live-contest/:contestId" element={<LiveContest />} />

			{/* Public profile page is kept for other roles but hidden from jobseekers */}
			<Route path="/profile/:userHandler" element={<Navigate to="/profile/edit" replace />} />

			<Route path="/profile/edit" element={<EditProfile />} />
			<Route path="/pif-profile/edit" element={<PifProfileEdit />} />
			<Route path="/profile/linkedin-edit" element={<EditProfileFromLinkedIn />} />

			{/* <Route path="/placement-prep" element={<PlacementPrep />} /> */}
			<Route path="/prepare" element={<Prepare />} />
			<Route path="/prepare/:questionId/attempt/:assessQuestionId" element={<PracticeQuestionsScreen />} />

			<Route path="/video-resume" element={<VideoAnswer />} />

			<Route path="/my-applications" element={<MyApplications />} />

			<Route path="/support" element={<Support />} />

			<Route path="/placement-drives" element={<PlacementDrivesListPage />} />
			<Route path="/placement-drives/:driveId/signin" element={<PlacementDriveSignInPage />} />
			<Route path="/placement-drives/:driveId/guest" element={<PlacementDriveSignInPage />} />
			<Route path="/placement-drives/:driveId/resume" element={<PlacementDriveResumePage />} />
			<Route path="/placement-drives/:driveId" element={<PlacementDriveDetailPage />} />
			<Route path="/placement-drives/:driveId/apply" element={<PlacementDriveApplyPage />} />
			<Route path="/placement-drives/:driveId/status" element={<PlacementDriveStatusPage />} />
			<Route path="/placement-drives/:driveId/companies" element={<PlacementDriveCompaniesPage />} />

			<Route path="/more-options" element={<MoreOptions />} />

			<Route path="/jap-success" element={<JapSuccessPage />} />

			{/* <Route path="/guest-user-assessment" element={<GuestUserAssessmentPage />} /> */}

			<Route path="/offline-drive-day-opportunities" element={<OfflineDriveDayOpportunitiesPage />} />
			<Route path="/offline-drive-attendance" element={<OfflineDriveAttendancePage />} />

			{/* <Route path="*" element={<Navigate to="/dashboard" />} /> */}
			<Route path="*" element={<Navigate to="/my-applications" />} />

			<Route path="/placement-drive-registration" element={<NonMasaiDrivePlacementPage />} />
		</Routes>
	);
};

export default JobseekerRoutes;
